import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const ArrowRightIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <Path d="M10 2L16 8M16 8L10 14M16 8H0" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

ArrowRightIcon.displayName = 'ArrowRightIcon';
